import { API_BASE_URL } from "../config";
import { DEFAULT_GEO_RESTRICTION_MESSAGE } from "../constants/geoRestriction";

/**
 * @returns {Promise<{
 *   allowed: boolean;
 *   restrictionEnabled: boolean;
 *   country?: string|null;
 *   licensedRegions?: string[];
 *   message?: string;
 * }>}
 */
export async function fetchGeoAccess({ signal } = {}) {
  const response = await fetch(`${API_BASE_URL}/api/geo/access`, {
    method: "GET",
    credentials: "omit",
    signal,
    headers: { Accept: "application/json" },
  });

  if (!response.ok) {
    throw new Error(`Geo access check failed (${response.status})`);
  }

  const data = await response.json();
  return {
    allowed: Boolean(data?.allowed),
    restrictionEnabled: Boolean(data?.restrictionEnabled),
    country: data?.country ?? null,
    licensedRegions: Array.isArray(data?.licensedRegions) ? data.licensedRegions : ["RW"],
    message: data?.message || DEFAULT_GEO_RESTRICTION_MESSAGE,
  };
}
